import React, { useCallback, useEffect, useState } from "react";
import { Link, Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import DashboardSide from "../../Components/Icons/DasboardSide";
import { GetAccess, GetDashboardRole, GetMultipleAccess } from "../../Components/Utils/roles";
import Items from "../../Components/Icons/Items";
import Products from "../../Components/Icons/Products";
import Bidding from "../../Components/Icons/Bidding";
import Procurement from "../../Components/Icons/Procurement";
import Project from "../../Components/Icons/Project";
import Sales from "../../Components/Icons/Sales";
import Payments from "../../Components/Icons/Payments";
import Store from "../../Components/Icons/Store";
import Members from "../../Components/Icons/Member";
import { Navbar, SideBar } from "../../Layouts/MainPage";
import { SidebarItem } from "../../Layouts/MainPage/SideBar";
import Costing from "../../Components/Icons/Budget";
import Progress from "../../Components/Icons/progress";
import PettyCash from "../../Components/Icons/PettyCash";
import Timesheet from "../../Components/Icons/TimeSheet";
import PlanTask from "../../Components/Icons/Planning";
import Task from "../../Components/Icons/Task";
import SubContracts from "../../Components/Icons/SubContracts";
import Report from "../../Components/Icons/Report";
import Finance from "../../Components/Icons/Finance";
import {
  LayoutDashboard,
  DollarSign,
  CalendarCheck,
  ListChecks,
  TrendingUp,
  Users,
  ShoppingCart,
  FileText,
  Warehouse,
  ClipboardCheck,
  FileSearch,
  Scale,
  Truck,
  Box,
  RefreshCw,
  Package,
  PackageCheck,
  FileInput,
  FileOutput
} from "lucide-react";

const MainProjectPage = () => {
  const {t} = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const {officeId} = useParams();
  const{projectId,projectID,projecTId,projeCtId,proJectId,projEctId}=useParams();


    // handle what happens on key press
    const handleKeyPress = useCallback((event) => {
      if(event.key === "Escape") {
        navigate(-1);
      }
    }, []);
  
    useEffect(() => {
      // attach the event listener
      document.addEventListener('keydown', handleKeyPress);
  
      // remove the event listener
      return () => {
        document.removeEventListener('keydown', handleKeyPress);
      };
    }, [handleKeyPress]);


  function isActiveFun(x){
    let actualPath = location.pathname.split("/")[2]
    let linkPath = ""
    if(x?.hasSubMenu){
      if(x?.subMenu){
         let y = x.subMenu[0].link;
         let z = y.split("/")[0]
         linkPath = z
      }
    }else{
      linkPath = x?.link;
    }
    if(linkPath.includes(actualPath)) {
      return true;
    }else{
      return false;
    }
  }




const effectiveProjectId = projectId || projectID || projecTId || projeCtId || proJectId || projEctId;

const navItem = [
  {
    icon: <LayoutDashboard size={16} />,
    title: "Dashboard",
    hasSubMenu: false,
    hasAccess: true,
    link: `/project/dashboard/${officeId}/${effectiveProjectId}`,
  },
  {
    icon: <DollarSign size={16} />,
    title: "Budget",
    hasSubMenu: false,
    hasAccess: ["manpower_view", "material_view", "others_view"],
    link: `/project/costing/man-power/${officeId}/${effectiveProjectId}`,
  },
  {
    icon: <CalendarCheck size={16} />,
    title: "Planning",
    hasSubMenu: false,
    hasAccess: ["activities_view", "timeline_view"],
    link: `/project/main-taskplan/main-task-plan/${officeId}/${effectiveProjectId}`,
  },
  {
    icon: <ListChecks size={16} />,
    title: "Task",
    hasSubMenu: false,
    hasAccess: ["my_task_view", "all_task_view"],
    link: `/project/tasks/my-task/${officeId}/${effectiveProjectId}`,
  },
  {
    icon: <TrendingUp size={16} />,
    title: "Progress",
    hasSubMenu: false,
    hasAccess: ["man_power", "material", "Equipment", "others"],
    link: `/project/progress/man-power/${officeId}/${effectiveProjectId}`,
  },
  {
    icon: <Users size={16} />,
    title: "HR",
    hasSubMenu: false,
    hasAccess: ["attendance", "timesheets", "team"],
    link: `/project/hr/attendance/${officeId}/${effectiveProjectId}`,
  },
  {
    icon: <ShoppingCart size={16} />,
    title: "Procurement",
    hasSubMenu: false,
    hasAccess: [
      "purchase_request_view",
      "rfq_view",
      "supplier_quote_view",
      "quote_compare_view",
      "purchase_order_view",
      "suppliers_view",
    ],
    link: `/project/procurement/ypr/${officeId}/${effectiveProjectId}`,
    subMenu: []
    
  },
  {
    icon: <FileText size={16} />,
    title: "Invoices",
    hasSubMenu: false,
    hasAccess: [
      // "customers_view",
      // "customer_quote_view",
      // "customer_order_view",
      // "sales_order_view",
      "invoice_in_view",
      "invoice_out_view",
      // "promotions_view",
    ],
    link: `/project/sales/invoice_incoming/${officeId}/${effectiveProjectId}`,
    subMenu: []
   
  },
  {
    icon: <Warehouse size={16} />,
    title: "Store",
    hasSubMenu: false,
    hasAccess: [
      "grn_view",
      "inventory_view",
      "assets_view",
      "delivery_notes_view",
      "packing_list_view",
      "returns_view",
      "requests_view",
      "shipment_status_view",
    ],
    link: `/project/store/shipment-status/${officeId}/${effectiveProjectId}`,
    subMenu: []
   
  },
];


  return (
    <div className=" w-full h-screen bg-slate-100 flex justify-start items-center overflow-hidden">
      <div className=" hidden w-16 z-[997] lg:block">
      <SideBar>
        {navItem && 
          navItem.map((item,idx) => {
            
            return (
              <>
              {
                (item?.hasAccess == true||GetMultipleAccess(item?.hasAccess||[]) )&&(<SidebarItem
                    icon={item?.icon}
                    text={t(item?.title)}
                    hasSubMenu={item?.hasSubMenu}
                    subItem={item?.subMenu}
                    link={item?.link}
                    active={isActiveFun(item)}
                    key={idx}
                  />
                )
              }
              </>
            );
          })}
      </SideBar>
      </div>
      <div className=" w-full h-[100vh]  ">
        <div className=" w-full h-[59px] bg-white z-50 shadow-lg">
          <Navbar />
        </div>
        <div className=" w-full h-[calc(100vh-87px)]  overflow-y-auto">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default MainProjectPage;
